// src/services/leadershipEngine/score.config.js

export const SCORE = {
  // ✅ NOVO SCORE OFICIAL
  MODE: 'ELION_6K',

  // ✅ total máximo do score
  MAX_TOTAL: 6000,

  // ✅ janela rotativa (rolling) — pontos expiram após X meses
  ROLLING_MONTHS: 12,

  /* ============================================================
     PILARES (cada um vale 1000 pts)
     - pontos por unidade é derivado de: 1000 / meta
  ============================================================ */
  PILARES: {
    IMOVEIS: {
      MAX: 1000,
      META: 70, // angariações/12m
    },
    NEGOCIOS: {
      MAX: 1000,
      META: 360, // negócios/12m
    },
    PLACAS: {
      MAX: 1000,
      META: 40, // placas (modelo atual: imoveis.temPlaca)
    },
    VISITAS: {
      MAX: 1000,
      META: 240, // visitas/12m
    },

    // ✅ FATURAMENTO = COMISSÃO (não VGV)
    COMISSAO: {
      MAX: 1000,
      META_12M: 1_000_000, // R$ 1.000.000 de comissão em 12m = 1000 pts
      // 1 pt a cada R$ 1k
      POINTS_PER_1000: 1,
      // fallback opcional (se comissao não preenchida)
      FALLBACK_RATE_ON_VGV: 0.03, // 3% sobre VGV (ajustável)
      USE_FALLBACK_IF_COMISSAO_MISSING: true,
    },
  },

  /* ============================================================
     PONTOS ELION (regras mensais)
  ============================================================ */
  ELION: {
    // se não registrar nada em nenhuma categoria no mês:
    PENITENCIA_SEM_MOVIMENTO_MENSAL: -100,

    // se movimentou todas as 5 categorias no mês:
    BONUS_FULL_PLAYER_MENSAL: 85,
  },

  /* ============================================================
     LEGADO (mantido só por compatibilidade / migração)
     - você pode remover depois que o Dashboard migrar 100%
  ============================================================ */
  LEGACY: {
    MAX_TOTAL: 1000,
    RENDA: {
      MAX: 400,
      META_12M: 600000,
      POINTS_PER_1000: 0.67,
      WINDOW_MONTHS: 12,
    },
    CONSTANCIA: {
      MAX: 100,
      STREAK_MESES: 3,
      POINTS_ON_STREAK: 100,
    },
    COMPORTAMENTO: {
      MAX: 500,
      IMOVEIS: { PTS: 25, MAX: 100 },
      NEGOCIOS: { PTS: 17, MAX: 170 },
      VISITAS: { PTS: 12, MAX: 180 },
      VENDAS: { PTS: 50, MAX: 150 },
    },
    DEPRECIACAO: {
      DAYS: 7,
      SEM_IMOVEL_7D: -10,
      SEM_NEGOCIO_7D: -18,
      SEM_VISITA_7D: -15,
    },
  },
};

export const EVENT_TYPES = {
  IMOVEL_CADASTRADO: 'IMOVEL_CADASTRADO',
  NEGOCIO_CADASTRADO: 'NEGOCIO_CADASTRADO',
  VISITA_REALIZADA: 'VISITA_REALIZADA',
  VENDA_CADASTRADA: 'VENDA_CADASTRADA',
};
